var detectIndent = require('detect-indent');

/**
 * Return indentation of a line
 * @param {String} line
 * @return {String}
 */
function getIndentForLine(line) {
  return detectIndent(line).indent || '';
}

module.exports = getIndentForLine;



//////////////////
// WEBPACK FOOTER
// ./node_modules/draft-js-code/lib/utils/getIndentForLine.js
// module id = 398
// module chunks = 0